import "./InformationSmallBanner.css";
import React from "react";
import CountUp from "react-countup";

export default function InformationSmallBanner({
  title,
  value,
  suffix,
  separator = ",",
  fontSizeCount = "22px",
  background = "rgba(67, 76, 230, 0.55)",
  onClick,
}) {
  const isNumeric = typeof value === "number" && !isNaN(value);

  return (
    <div
      className={`isb-glass ${onClick ? "isb-clickable" : ""}`}
      style={{ background }}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={(e) => {
        if (!onClick) return;
        if (e.key === "Enter" || e.key === " ") onClick();
      }}
    >
      <div className="isb-title" title={title}>
        {title}
      </div>

      <div className="isb-divider" />

      <div className="isb-value" style={{ fontSize: fontSizeCount }}>
        {isNumeric ? (
          <CountUp duration={1} end={value} separator={separator} />
        ) : (
          <span>{value ?? "—"}</span>
        )}

        {suffix ? <span className="isb-suffix">{suffix}</span> : null}
      </div>
    </div>
  );
}
